import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card } from '../components/ui/card';
import { toast } from 'sonner';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/api/auth/forgot-password`, { email, origin_url: window.location.origin });
      setSent(true);
      toast.success('Check your email for a reset link');
    } catch (error) {
      toast.error('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 bg-muted/30">
      <Card className="w-full max-w-md p-8 rounded-2xl shadow-sm">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-serif mb-2" data-testid="forgot-heading">
            {sent ? 'Check Your Email' : 'Forgot Password'}
          </h1>
          <p className="text-muted-foreground">
            {sent 
              ? "We've sent a password reset link to your email. It expires in 1 hour."
              : "Enter your email and we'll send you a link to reset your password."
            }
          </p>
        </div>

        {!sent ? (
          <form onSubmit={handleSubmit} className="space-y-6" data-testid="forgot-form">
            <div>
              <Label htmlFor="email">Email</Label>
              <Input
                id="email"
                type="email"
                data-testid="forgot-email-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="mt-2 rounded-xl border-2 border-muted-foreground/30"
                placeholder="you@example.com"
              />
            </div>

            <Button
              type="submit"
              disabled={loading}
              data-testid="forgot-submit-btn"
              className="w-full rounded-full bg-primary hover:bg-primary/90"
            >
              {loading ? 'Sending...' : 'Send Reset Link'}
            </Button>
          </form>
        ) : (
          <div className="text-center space-y-4">
            <p className="text-sm text-muted-foreground">
              Didn't receive it? Check your spam folder or try again.
            </p>
            <Button
              variant="outline"
              onClick={() => setSent(false)}
              className="rounded-full"
              data-testid="try-again-btn"
            >
              Try Again
            </Button>
          </div>
        )}

        <div className="mt-6 text-center">
          <Link to="/login" className="text-sm text-muted-foreground hover:text-foreground duration-300" data-testid="back-to-login-link">
            ← Back to Login
          </Link>
        </div>
      </Card>
    </div>
  );
}
